export default __webpack_public_path__ + "static/media/0e8ba32687334b2c0d4d0c1af56917341581619082958.3c8ff8fd.webp";